import { network } from 'services/network';

export const externalLogin = (params) => {
    return network
        .post(`https://${params.domain}/v1.0/admin/bo/login`, {
            username: params.username,
            password: params.password,
        })
        .then((response) => {
            return response.data;
        });
};
